<template>
  <v-breadcrumbs :items="items" class="px-0">
    <template v-slot:item="scope">
      <BaseButton
        class="title-font darkGray--text justify-start mr-2"
        icon
        @click="previousStep(scope.item.to)"
        width="17"
        v-if="!visibleButton"
      >
        <img :src="require('@/assets/ic_head_voltar.svg')" />
      </BaseButton>
      <span class="title-font darkGray--text">
        {{ scope.item.text }}
      </span>
    </template>
  </v-breadcrumbs>
</template>
<script>
export default {
  methods: {
    previousStep(item) {
      this.$emit("return", item);
    }
  },
  props: {
    items: {
      type: Array
    },
    visibleButton: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="sass" scoped>
.v-breadcrumbs li .v-icon.breadcrumb--divider
  font-size: 20px
.title-font
  font-size: 20px
  font-weight: 700
  @media(max-width:600px)
    font-size: 16px
</style>
